import { createEffect, createEvent, sample } from 'effector';
import { devicesEntity, TableDataRecord } from '@entities/devices';

const exportData = createEvent();

type ExportFxPayload = {
  stats: {
    min: null | number,
    max: null | number,
    avg: null | number
  },
  records: TableDataRecord[],
}

const exportFx = createEffect(({ stats, records }: ExportFxPayload) => {
  const header = ['Time', 'Value', 'Unit'];
  const statsHeader = ['Min', 'Max', 'Avg'];

  const statsRow = [
    stats.min ?? '',
    stats.max ?? '',
    stats.avg ?? ''
  ];

  const csvRows: string[] = [];

  csvRows.push(statsHeader.join(','));
  csvRows.push(statsRow.join(','));
  csvRows.push('');
  csvRows.push(header.join(','));

  for (const record of records) {
    csvRows.push([record.time, record.value, record.unit].join(','));
  }

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `sensor_data_${Date.now()}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
});

sample({
  clock: exportData,
  source: {
    stats: devicesEntity.$stats,
    records: devicesEntity.$tableData,
  },
  target: exportFx,
});

export const exportSensorDataModel = {
  exportData
}